import { makeStyles, typographyStyles } from "@fluentui/react-components";
import { CustomCardHeader } from "./CustomCardHeader";
import { Column, ColumnProps } from "./Column";
import { appTokens } from "./Styles/appTokens";

const useStyles = makeStyles({
    formSection: {
        paddingBlock: '.5rem',
        paddingInline: '1rem',
        border: `1px solid ${appTokens.border.colors.subtle}`,
    },
    formSectionHeader: {
    },
    formSectionTitle: {
        ...typographyStyles.subtitle2,
        fontWeight: '600',
        fontStyle: 'italic',
    },
});

type FormSectionProps = ColumnProps & {
    title?: string;
    children?: React.ReactNode;    
    disabled?: boolean;
    action?: JSX.Element;
    headerComponent?: JSX.Element;
    info?: string | JSX.Element;
    description?: string | JSX.Element;
    scroll?: boolean;
}
export const FormSection = (props: FormSectionProps) => {

    const { title, children, padding, disabled = false, action, headerComponent, info, description, scroll=true, ...otherProps } = props;

    //Styles
    const styles = useStyles();

    return (
        <>
            <Column  gap='small'
                padding='px-3 py-2'
                borderRadius='10px'
                subtleBorder
                shadow={false}
                {...otherProps}
            >
                {title && (
                    <CustomCardHeader info={info} headerComponent={headerComponent} action={action} title={title} className={styles.formSectionHeader} titleClassName={styles.formSectionTitle} disabled={disabled} description={description} />
                )}
                <Column flex='1' padding='py-1' width='100%' scroll={scroll}>
                    <Column padding={padding}>
                        {children}
                    </Column>
                </Column>
            </Column>
        </>
    );
}